import { Injectable, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { APP_ENVIRONMENT } from '@core/tokens/environment.token';

export type AppLanguage = 'en' | 'ar';

const STORAGE_KEY = 'kssap.language';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly translate = inject(TranslateService);
  private readonly env = inject(APP_ENVIRONMENT);

  readonly currentLang = signal<AppLanguage>(this.resolveInitialLang());

  init(): void {
    const lang = this.currentLang();
    this.translate.addLangs(['en', 'ar']);
    this.apply(lang);
  }

  setLanguage(lang: AppLanguage): void {
    if (lang === this.currentLang()) {
      return;
    }

    localStorage.setItem(STORAGE_KEY, lang);
    this.currentLang.set(lang);
    this.apply(lang);
  }

  toggle(): void {
    this.setLanguage(this.currentLang() === 'en' ? 'ar' : 'en');
  }

  private resolveInitialLang(): AppLanguage {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'en' || saved === 'ar') {
      return saved;
    }

    return this.env.defaultLanguage === 'ar' ? 'ar' : 'en';
  }

  private apply(lang: AppLanguage): void {
    void this.translate.use(lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }
}
